// ENV should be populated from process.env at build time
let env = ENV || {};

let loadedAtDate = new Date();
let buildDate = null;

try {
  let buildTime = Date.parse(env.BUILD_DATE);
  buildDate = new Date(buildTime);
} catch (e) {
  console.error("Couldn't calculate buildAge:", e);
}

env.loadedAtDate = loadedAtDate;
env.buildDate = buildDate;

export default env;
